import { FC, PropsWithChildren, ReactNode, useCallback, useMemo, useState } from 'react'
import { Card, Tabs, Collapse } from "antd"
import { DownOutlined, UpOutlined } from '@ant-design/icons'

type PropType = FC<PropsWithChildren<{
  className?: string
  title: string | ReactNode
  items: {label: string, key: string, children: ReactNode, forceRender?: boolean}[]
  hideCollapse?: boolean
}>>

const CollapseCard: PropType = ({title, items, className, hideCollapse}) => {
  const [collapse, setCollapse] = useState(false)

  const tabsItems = useMemo(() => {
    return items.map(item => {
      return {
        ...item,
        children: (
          <Collapse activeKey={collapse ? null : '1'} className='collapse-header-none'>
            <Collapse.Panel header={null} key="1">
              <div className='ptb-10 plr-16'>{item.children}</div>
            </Collapse.Panel>
          </Collapse>
        )
      }
    })
  }, [items, collapse])

  const handleCollapse = useCallback((val) => {
    setCollapse(val)
  }, [])

  return (
    <div className={className}>
      <Card size='small' bodyStyle={{padding: 0}}>
        <Tabs
          size="small"
          className={`collapse-tabs ${collapse ? 'collapse' : ''}`}
          tabBarExtraContent={{
            left: typeof title === 'string' ? <span className='mr-20 font-700 font-16'>{title}</span> : title,
            right: !hideCollapse && (collapse ? <span className='link' onClick={() => handleCollapse(false)}><DownOutlined />展开</span> : <span className='link' onClick={() => handleCollapse(true)}><UpOutlined />收起</span>)
          }}
          items={tabsItems}
        />
      </Card>
    </div>
  )
}

export default CollapseCard
